import { number, object } from 'yup';
import { CycleSettingAction } from '../../enums/action';
import { PreheatActions } from '../../types/cycle-settings-types';
import i18n from '../../infrastructure/i18n';

export const PREHEAT_SETTINGS_LIMITS = {
  RATE: {
    MIN: 0,
    MAX: 2222,
  },
  FINAL_TEMPERATURE: {
    MIN: 1,
    MAX: 1315.5,
  },
  UPPER_HOLD_TOLERANCE: {
    MIN: 0,
    MAX: 1000,
  },
  LOWER_HOLD_TOLERANCE: {
    MIN: 0,
    MAX: 1000,
  },
};

export const actions: PreheatActions[] = [
  {
    inputType: 'number',
    actionName: CycleSettingAction.SET_PREHEAT_RATE,
    actionField: 'rt',
    editableKey: 'rate',
    labelText: i18n.t('cycle.settings.preHeat.rt'),
    validationSchema: object({
      rt: number()
        .typeError(i18n.t('errors.numberValue.typeError', '', { type: 'number' }))
        .min(
          PREHEAT_SETTINGS_LIMITS.RATE.MIN,
          i18n.t('errors.numberValue.min', '', { minNum: PREHEAT_SETTINGS_LIMITS.RATE.MIN }),
        )
        .max(
          PREHEAT_SETTINGS_LIMITS.RATE.MAX,
          i18n.t('errors.numberValue.max', '', { maxNum: PREHEAT_SETTINGS_LIMITS.RATE.MAX }),
        )
        .required(i18n.t('errors.requiredValue')),
    }),
  },
  {
    inputType: 'number',
    actionName: CycleSettingAction.SET_PREHEAT_HOLDING_TEMPERATURE,
    actionField: 'ht',
    labelText: i18n.t('cycle.settings.preHeat.ht'),
    editableKey: 'finalTemp',
    validationSchema: object({
      ht: number()
        .typeError(i18n.t('errors.numberValue.typeError', '', { type: 'number' }))
        .min(
          PREHEAT_SETTINGS_LIMITS.FINAL_TEMPERATURE.MIN,
          i18n.t('errors.numberValue.min', '', { minNum: PREHEAT_SETTINGS_LIMITS.FINAL_TEMPERATURE.MIN }),
        )
        .max(
          PREHEAT_SETTINGS_LIMITS.FINAL_TEMPERATURE.MAX,
          i18n.t('errors.numberValue.max', '', { maxNum: PREHEAT_SETTINGS_LIMITS.FINAL_TEMPERATURE.MAX }),
        )
        .required(i18n.t('errors.requiredValue')),
    }),
  },
  {
    inputType: 'number',
    actionName: CycleSettingAction.SET_PREHEAT_UPPER_HOLD_TOLERANCE,
    actionField: 'up',
    labelText: i18n.t('cycle.settings.preHeat.up'),
    editableKey: 'soakUpper',
    validationSchema: object({
      up: number()
        .typeError(i18n.t('errors.numberValue.typeError', '', { type: 'number' }))
        .min(
          PREHEAT_SETTINGS_LIMITS.UPPER_HOLD_TOLERANCE.MIN,
          i18n.t('errors.numberValue.min', '', { minNum: PREHEAT_SETTINGS_LIMITS.UPPER_HOLD_TOLERANCE.MIN }),
        )
        .max(
          PREHEAT_SETTINGS_LIMITS.UPPER_HOLD_TOLERANCE.MAX,
          i18n.t('errors.numberValue.max', '', { maxNum: PREHEAT_SETTINGS_LIMITS.UPPER_HOLD_TOLERANCE.MAX }),
        )
        .required(i18n.t('errors.requiredValue')),
    }),
  },
  {
    inputType: 'number',
    actionName: CycleSettingAction.SET_PREHEAT_LOWER_HOLD_TOLERANCE,
    actionField: 'lw',
    labelText: i18n.t('cycle.settings.preHeat.lw'),
    editableKey: 'soakLower',
    validationSchema: object({
      lw: number()
        .typeError(i18n.t('errors.numberValue.typeError', '', { type: 'number' }))
        .min(
          PREHEAT_SETTINGS_LIMITS.LOWER_HOLD_TOLERANCE.MIN,
          i18n.t('errors.numberValue.min', '', { minNum: PREHEAT_SETTINGS_LIMITS.LOWER_HOLD_TOLERANCE.MIN }),
        )
        .max(
          PREHEAT_SETTINGS_LIMITS.LOWER_HOLD_TOLERANCE.MAX,
          i18n.t('errors.numberValue.max', '', { maxNum: PREHEAT_SETTINGS_LIMITS.LOWER_HOLD_TOLERANCE.MAX }),
        )
        .required(i18n.t('errors.requiredValue')),
    }),
  },
];

export const preHeatSettingActions = [
  {
    labelText: i18n.t('cycle.settings.postWeld.recipeName'),
    fieldName: 'name',
  },
  {
    labelText: i18n.t('cycle.settings.mode'),
    fieldName: 'mode',
  },
  {
    labelText: i18n.t('cycle.settings.preHeat.rt'),
    fieldName: 'rate',
  },
  {
    labelText: i18n.t('cycle.settings.preHeat.ht'),
    fieldName: 'holdingTemperature',
  },

  {
    labelText: i18n.t('cycle.settings.preHeat.up'),
    fieldName: 'soakUpper',
  },
  {
    labelText: i18n.t('cycle.settings.preHeat.lw'),
    fieldName: 'soakLower',
  },
]
